export default [
  {
    path: '/content/home',
    name: 'Home Content Admin',
    title: 'Home',
    component: () =>
      import(/* webpackChunkName: 'home-content-admin' */ './views/Index.vue')
  }
]
